import { render } from "./turmas_do_coordenador.vue?vue&type=template&id=360eb93e&scoped=true"
import script from "./turmas_do_coordenador.vue?vue&type=script&lang=js"
export * from "./turmas_do_coordenador.vue?vue&type=script&lang=js"

import "./turmas_do_coordenador.vue?vue&type=style&index=0&id=360eb93e&lang=scss&scoped=true"
import "./turmas_do_coordenador.vue?vue&type=style&index=1&id=360eb93e&lang=css"
import "./turmas_do_coordenador.vue?vue&type=style&index=2&id=360eb93e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360eb93e"]])

export default __exports__